import OrganizersTableHelper from "./organizer-table-helper";

const OrganizersHelpers = {
  TableMain: OrganizersTableHelper,
};

export default OrganizersHelpers;
